const ITEMS = [
  "Sale & Purchase",
  "Green Ship Recycling",
  "HKC Compliant",
  "Global Brokerage",
  "Dubai — JLT",
  "Cash Buyer Network",
];

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="h-2 w-2 shrink-0" aria-hidden="true">
    <rect x="1.8" y="1.8" width="6.4" height="6.4" transform="rotate(45 5 5)" fill="none" stroke="#C5A059" strokeWidth="1" opacity="0.5" />
  </svg>
);

export default function Marquee() {
  const row = ITEMS.map((item, i) => (
    <span key={i} className="mx-10 flex items-center gap-10">
      <span className="whitespace-nowrap font-serif text-2xl italic tracking-wide text-[#C5A059]/30 sm:text-3xl">
        {item}
      </span>
      <Diamond />
    </span>
  ));
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#1E3A6E]/50 bg-[#071838]/40 py-7"
    >
      <div className="marquee-track flex w-max">
        {row}
        {ITEMS.map((item, i) => (
          <span key={`dup-${i}`} className="mx-10 flex items-center gap-10" aria-hidden="true">
            <span className="whitespace-nowrap font-serif text-2xl italic tracking-wide text-[#C5A059]/30 sm:text-3xl">
              {item}
            </span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
}
